@use './shared';

$_SELECTOR: '.joy-user-card';

:host {
    /**
    * @prop --user-card-text-color: Set text content color
    * @prop --user-card-font-size: Set text content font-size
    */
    --user-card-links-color: var(--joy-color-secondary-50);
    --user-card-links-color-hover-focus: var(--joy-color-secondary-90);
    --user-card-text-color: var(--joy-color-neutral-60);
    --user-card-font-size: var(--joy-font-size-primary-400);

    display: inline-flex;
    font-family: var(--joy-font-family);
}

::slotted(strong) {
    display: block;
    font-weight: 700;
}

::slotted(p) {
    margin: 0;
    color: var(--user-card-text-color);
    display: block;
    font-size: var(--user-card-font-size);
    font-family: inherit;
}

a#{$_SELECTOR} {
    #{$_SELECTOR}__title {
        color: var(--user-card-links-color);
    }

    &:hover {
        #{$_SELECTOR}__title {
            text-decoration: underline;
        }
    }

}

$_PIC_SIZE: 60px;

#{$_SELECTOR} {
    display: flex;
    align-items: flex-start;
    text-decoration: none;

    &__picture {
        margin-right: var(--joy-core-spacing-3);
    }

    &__informations {
        color: var(--user-card-text-color);
        font-size: var(--user-card-font-size);

        a {
            @include shared.links();
        }

        @media screen and (max-width: 479px) {
            margin-left: var(--joy-core-spacing-1);
        }

        p, a {
            display: block;
            margin: 0;
            word-break: break-word;
        }

        joy-rating-stars {
            margin-left: 0;
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &__title {
        font-size: inherit;
        font-weight: bold;
        line-height: var(--joy-line-height-large);
    }

    &__subtitle {
        font-size: inherit;
        font-weight: normal;
        line-height: var(--joy-line-height-large);
    }

    &__other {
        font-size: inherit;
        text-decoration: none;
        color: var(--user-card-text-color);
    }

}